import { useState, useEffect } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import SubPageHeader from '../SubPageHeader';
import CurrencyForm from '../CurrencyForm';
import { Button } from '@/components/ui/button';
import { api } from '@/api/apiClient';

/** Settings → العملة والضريبة (SellGo's own database). */
export default function CurrencySection({ onBack }) {
  const [company, setCompany] = useState(null);
  const [error, setError] = useState(null);

  const load = async () => {
    setError(null);
    try {
      const res = await api.get('/sellgo_company');
      setCompany(res?.data || {});
    } catch (e) {
      setError(e?.message || 'تعذّر تحميل بيانات الشركة');
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="العملة والضريبة" onBack={onBack} />
      <div className="p-4">
        {!company && !error && (
          <div className="flex justify-center py-12"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>
        )}
        {error && (
          <div className="flex flex-col items-center gap-3 py-10 text-center">
            <AlertCircle className="w-10 h-10 text-red-500" />
            <p className="text-sm font-semibold text-foreground">{error}</p>
            <Button variant="outline" size="sm" onClick={load}>إعادة المحاولة</Button>
          </div>
        )}
        {company && <CurrencyForm company={company} onSaved={setCompany} />}
      </div>
    </div>
  );
}
